import { useEffect } from 'react'
import { useAppStore } from '@/store/appStore'

type OverlayType = 'overview' | 'appendices' | 'glossary' | 'release-notes' | 'user-content' | 'faq' | 'crosswalks'

const HASH_MAP: Record<string, OverlayType> = {
  'show-glossary': 'glossary',
  'show-overview': 'overview',
  'show-release-notes': 'release-notes',
  'show-faq': 'faq',
  'show-appendices': 'appendices',
  'show-user-content': 'user-content',
  'show-crosswalks': 'crosswalks',
}

function openFromHash(hash: string, setOverlayPage: (p: { type: OverlayType } | null) => void) {
  const key = hash.replace(/^#/, '')
  const type = HASH_MAP[key]
  if (type) setOverlayPage({ type })
}

export function useHashOverlay() {
  const setOverlayPage = useAppStore((s) => s.setOverlayPage)

  useEffect(() => {
    // Open on page load if hash is already present
    if (window.location.hash) openFromHash(window.location.hash, setOverlayPage)

    // Intercept clicks on any <a href="#show-{x}"> anywhere in the document
    const handleClick = (e: MouseEvent) => {
      const anchor = (e.target as Element).closest('a')
      if (!anchor) return
      const href = anchor.getAttribute('href') ?? ''
      if (!href.startsWith('#show-')) return
      const type = HASH_MAP[href.slice(1)]
      if (!type) return
      e.preventDefault()
      setOverlayPage({ type })
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [setOverlayPage])
}
